import Tabs from "@/common/components/Tabs";
import { defaultTabs } from "../../constants/TmaisUsersShowTabs.constant";
import { ShowHeader } from "@/common/components/ShowHeader";
import { useParams } from "react-router-dom";
import useTmaisUser from "../../hooks/useTmaisUser";
import { TmaisUserData } from "../../types/tmaisUsers.type";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";

const Show = () => {
  const {id} = useParams()

  const {
    data: tmaisUser,
    error: tmaisUserError = {} as any,
    refetch: refetchTmaisUsers
  } = useTmaisUser(String(id))

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-128px)]"
      statusCode={tmaisUserError?.status}
      refetchFunction={refetchTmaisUsers}
    >
      <div className="flex flex-col">
        <ShowHeader
          goBack
          goBackProps={{
            fallback: '/tmais-users'
          }}
          title="Clientes"
          subtitle={(
            <h2 className="text-white-800">
              {tmaisUser?.full_name}
            </h2>
          )}
        />

        <Tabs
          tabsListClassName="flex h-auto flex-row flex-wrap justify-start w-full bg-transparent rounded-none"
          tabsTriggerClassName="flex-1 h-8 transition-none duration-0 rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
          tabsContentClassName="mt-6"
          tabsList={defaultTabs({tmaisUser: tmaisUser as TmaisUserData})}
        />
      </div>
    </ErrorMessageWrapper>
  );
};

 export default Show;
